import { LiveAnnouncer } from "@angular/cdk/a11y";
import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { AlertMessageService } from "@bundle/component/alert-message/alert-message.service";
import { AppMasterService } from "app/business/service/app/app-master.service";
import { AppMenuService } from "app/business/service/app/app-menu.service";
import { AuthService } from "app/core/auth/auth.service";

@Component({
  selector: "app-config-validation-settings",
  templateUrl: "./config-validation-settings.component.html",
  styleUrls: ["./config-validation-settings.component.scss"],
})
export class ConfigValidationSettingsComponent implements OnInit {
  form: any = {};
  displayedColumns: string[] = [
    "bankCodeName",
    "bankAccountName",
    "bankAccountNo",
    "bankBranch",
    "accTaxNo",
    "isActive",
    "action",
  ];
  buttonList: any[] = [];
  itemList: any;
  userToken: any;
  url: string;
  previewMode: string[] = []; // tracks mode per item: 'edit' | 'preview' | 'split'

  constructor(
    private router: Router,
    private appMasterService: AppMasterService,
    private appMenuService: AppMenuService,
    private _authService: AuthService,
    private alert: AlertMessageService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.userToken = JSON.parse(this._authService.loginUser);

    await this.getRouter();
    await this.loadData();
  }

  async getRouter(): Promise<void> {
    this.url = this.router.url;

    const formData = {
      url: this.url,
      userGroupCode: this.userToken.userGroupCode,
      userRoleCode: this.userToken.userRoleCode,
      userCode: this.userToken.userCode,
    };

    this.buttonList =
      await this.appMenuService.getButtonPermissionPerPages(formData);
  }

  async loadData() {
    const dataReq = {
      configHCode: "VALIDATE_FOOTNOTE",
    };

    await this.appMasterService
      .getMasterConfigList(dataReq)
      .then((res: any) => {
        if (res === "error") {
          return;
        } else {
          this.itemList = res;
          this.previewMode = res.map(() => "edit");
        }
      });
  }

  checkButton(buttonCode: string) {
    var checkBtn = this.buttonList.find((e) => e.buttonCode == buttonCode);

    if (checkBtn != undefined) {
      return true;
    } else {
      return false;
    }
  }

  async updateItem(item: any) {
    console.log(item);

    const payLoad = {
      configHCode: item.validateFootnoteHeaderCode,
      configDCode: item.validateFootnoteCode,
      configTName: item.validateFootnoteTName,
      configEName: item.validateFootnoteEName,
      configValue: item.validateFootnoteValue,
      configRemark: item.validateFootnoteRemark,
    };

    await this.appMasterService.updateMasterConfig(payLoad).then((res: any) => {
      if (res === "error") {
        return;
      } else {
        this.alert.open({
          message: "บันทึกสำเร็จ",
          title: "",
        });

        this.loadData();
      }
    });
  }
}
